import React from 'react';
import styles from '../BetSlip.module.scss';
import { BET_PLACEMENT_SUBMIT_BUTTON_TYPES, BET_SLIP_TABS } from '../../../constants/defaultValues';
import { roundNumber } from '../../../utils/formatDecimal';
import { useDispatch, useSelector } from 'react-redux';
import betSlipCalculator from '../../../utils/betSlipCalculator';
import { getTranslation } from '../../../utils/translation';
import { acceptOddChangeEnum } from '../../../constants/enums';
import {
    changeBetSlipOddDecision,
    clearPlaceBetErrors,
    changeBetSlipSubmitButtonType,
} from '../../../store/actions/betSlip';
import commonStyles from '../BetSlip.module.scss';

const Footer = props => {
    const dispatch = useDispatch();
    const {
        validations,
        activeTab,
        betLines,
        stakes,
        selectedCombinations,
        isTicketSubmitting,
        submitButtonType,
    } = useSelector(state => state.betSlip);
    const producerStatuses = useSelector(state => state.feed.producerStatuses);
    const { isSocketConnected } = useSelector(state => state.socket);
    const isMaxStakeLoading = useSelector(state => state.betSlip.isMaxStakeLoading);

    const { potentialPayout } = betSlipCalculator.calculateTicketDetails({
        betLines,
        activeTab,
        stakes,
        selectedCombinations,
    });

    const isPlaceBetDisabled = () => {
        let hasError = false;

        if (activeTab === BET_SLIP_TABS.single.id) {
            hasError = validations.single.length > 0 || validations.common.length > 0;
        } else if (activeTab === BET_SLIP_TABS.combo.id) {
            hasError = validations.combo.length > 0 || validations.common.length > 0;
        } else if (activeTab === BET_SLIP_TABS.system.id) {
            hasError = validations.system.length > 0 || validations.common.length > 0;
        }

        const hasClosedBet = betLines.some(b => b.closed);
        const isCombinationsSelected =
            activeTab !== BET_SLIP_TABS.system.id || selectedCombinations.length > 0;
        const isPreMatchProducerDown =
            producerStatuses.isPreMatchDown && betLines.some(b => !b.isLive);
        const isLiveProducerDown = producerStatuses.isLiveDown && betLines.some(b => b.isLive);

        return (
            hasError ||
            hasClosedBet ||
            !isCombinationsSelected ||
            isPreMatchProducerDown ||
            isLiveProducerDown
        );
    };

    const onPlaceBetClick = () => {
        if (isPlaceBetDisabled() || isTicketSubmitting) return;

        props.onPlaceBetClick();
    };

    const onAutoAcceptClick = () => {
        dispatch(changeBetSlipOddDecision(acceptOddChangeEnum.YES));
        dispatch(changeBetSlipSubmitButtonType(BET_PLACEMENT_SUBMIT_BUTTON_TYPES.submit));
        props.onPlaceBetClick({ oddChangeDecision: acceptOddChangeEnum.YES });
    };

    const onManualAcceptClick = () => {
        dispatch(clearPlaceBetErrors());
        dispatch(changeBetSlipSubmitButtonType(BET_PLACEMENT_SUBMIT_BUTTON_TYPES.submit));
    };

    return (
        <>
            {submitButtonType === BET_PLACEMENT_SUBMIT_BUTTON_TYPES.submit && (
                <div className={styles.betSlipAction}>
                    <div className='total'>
                        <p className={styles.totalText}>
                            {getTranslation('betSlip.placeBets.potentialPayout')}
                        </p>
                        <span className={styles.totalPrice}>
                            {roundNumber(potentialPayout, 2)} AZN
                        </span>
                    </div>
                    <button
                        className={`${styles.betSlipButton} ${styles.red}`}
                        disabled={
                            isPlaceBetDisabled() ||
                            isTicketSubmitting ||
                            !isSocketConnected ||
                            isMaxStakeLoading
                        }
                        onClick={onPlaceBetClick}
                    >
                        {getTranslation('betSlip.actions.placeBets')}
                    </button>
                </div>
            )}
            {submitButtonType === BET_PLACEMENT_SUBMIT_BUTTON_TYPES.confirm && (
                <div className={`${commonStyles.betSlipAction} d-block`}>
                    <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                        {getTranslation('betSlip.placeBets.acceptOddChanges')}
                    </p>
                    <div className='flex justify-center'>
                        <button
                            className={`${styles.betSlipButton} ${styles.green} m-r-3`}
                            style={{ width: '160px' }}
                            onClick={onAutoAcceptClick}
                            disabled={!isSocketConnected}
                        >
                            {getTranslation('betSlip.actions.autoAccept')}
                        </button>
                        <button
                            className={styles.betSlipButton}
                            style={{ width: '116px' }}
                            onClick={onManualAcceptClick}
                        >
                            {getTranslation('betSlip.actions.manually')}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;
